export const SubmissionPopUpIllustration = 'https://pinhome-web-assets.imgix.net/pinfinance/submission-illustration-2.png';
